import makeBasicTheme from '../makeBasicTheme'
const mainColor = "#3179bf"
export default makeBasicTheme(mainColor)